import React from 'react'
import { MDBBtn, MDBAlert, MDBCard, MDBCardBody, MDBCol, MDBRow, MDBFooter, MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter } from 'mdbreact';
import axios from '../../authAxios'
import { Avatar } from 'antd';
import profile_pic from '../../Assets/blank-profile-picture.png';
import { FilePicker } from 'react-file-picker'
import TextField from '@material-ui/core/TextField';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import profile_pic_default from '../../Assets/blank-profile-picture.png';
import sha256 from 'sha256';
import { Redirect } from 'react-router-dom';

// const brand_color = localStorage.getItem('brand_color')

export class MyProfile extends React.Component {
    constructor(props) {
        super(props)
        var today = new Date()
        this.state = {
            brand_color : "" ,
            user_id: '',
            first_name: '',
            last_name: '',
            email: '',
            country: '',
            address: '',
            mobile: '',
            profilePicUrl: profile_pic,
            userDataObj: [],
            uploadBtnClicked: false,
            selectedFile: '',
            uploadPercentage: 0,
            isFirstnameValid: false,
            firstname_error_text: '',

            isLastnameValid: false,
            lastname_error_text: '',

            isEmailValid: false,
            email_error_text: '',

            isMobileValid: false,
            mobile_error_text: '',

            selectedDOB: '',
            genderValue: '',
            isMaleChecked: false,
            isFemaleChecked: false,
            isError: false,
            ErrorMsg: '',
            showSuccessMSg: false,

            confirmPassErrormsg: '',
            confirm_password: '',
            isConfirmError: false,
            isNewPassError: false,
            new_password: '',
            newPassErrormsg: '',
            showChangePassModal: false,
            newPasswordHidden: true,
            confirmPasswordHidden: true,
            proceed: false,
            showCalendar:false

        }
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this)
        this.handleChangePassClick = this.handleChangePassClick.bind(this)
        this.handleUpdatePassword = this.handleUpdatePassword.bind(this)
    }
    componentDidMount() {
        this.setState({brand_color : localStorage.getItem("brand_color")})
        // console.log("userid")
        localStorage.setItem("DOBStr", "")
        // console.log(localStorage.getItem("user_id"))
        this.setState({
            user_id: localStorage.getItem("user_id")
        })
        this.api_getUserProfile()
    }
    handleUploadBtnClick = e => {
        this.setState({ uploadBtnClicked: true })
    }
    handleUpdateBtnClick = () => {
        var dob = localStorage.getItem("DOBStr")
        // console.log("api-===")
        // console.log(this.state.selectedDOB)
        // console.log(dob)
        // console.log(this.state.genderValue)
        var str = this.state.first_name.replace("\n", "").trim()
        if (str === '') {
            this.setState({
                isFirstnameValid: true,
                firstname_error_text: "Please enter first name",
                first_name:str
            })
            return
        }
        if (this.state.first_name.length < 2) {
            this.setState({
                isFirstnameValid: true,
                firstname_error_text: "First name at least 2 characters long"
            })
            return
        }
        var lastStr = this.state.last_name.replace("\n", "").trim()
        if (lastStr === "") {
            this.setState({
                isLastnameValid: true,
                lastname_error_text: "Please enter last name",
                last_name:lastStr
            })
            return
        }
        if (this.state.last_name.length < 2) {
            this.setState({
                isLastnameValid: true,
                lastname_error_text: "Last name at least 2 characters long"
            })
            return
        }
        if ((this.state.selectedDOB === '') || (this.state.selectedDOB === null) || (dob === "")) {
            this.setState({
                isError: true,
                ErrorMsg: "Please select Date of birth"
            })
            return
        }
        if (new Date(this.state.selectedDOB) == 'Invalid Date') {
            this.setState({
                isError: true,
                ErrorMsg: "Please select proper Date of birth"
            })
            return
        }

        if (this.state.genderValue === "") {
            this.setState({
                isError: true,
                ErrorMsg: "Please select gender"
            })
            return
        }
        this.api_UpdateUserData()
    }
    check_profile_data_filled(){
        var dob = localStorage.getItem("DOBStr")
        var str = this.state.first_name.replace("\n", "").trim()
        if (str === '') {
            return false
        }
        if (this.state.first_name.length < 2) {
            return false
        }
        var lastStr = this.state.last_name.replace("\n", "").trim()
        if (lastStr === "") {
            return false
        }
        if (this.state.last_name.length < 2) {
            return false
        }
        if ((this.state.selectedDOB === '') || (this.state.selectedDOB === null) || (dob === "")) {
            return false
        }
        if (new Date(this.state.selectedDOB) == 'Invalid Date') {
            return false
        }

        if (this.state.genderValue === "") {
            return false
        }

        return true
    }

    handleFistname = e => {
        this.setState({
            isFirstnameValid: false,
            firstname_error_text: ""
        })
        // this.textInput2.focus();
        this.setState({ first_name: e.target.value })
    }

    handleLastname = e => {
        this.setState({
            isLastnameValid: false,
            lastname_error_text: ""
        })
        this.setState({ last_name: e.target.value })

    }

    handleEmail = e => {
        this.setState({
            isEmailValid: false,
            email_error_text: ""
        })
        this.setState({ email: e.target.value })
    }
    handleMobile = e => {
        this.setState({
            isMobileValid: false,
            mobile_error_text: ''

        })
    }

    handleStartDateChange = date => {
        this.setState({
            isError: false,
            ErrorMsg: "Please select gender"
        })
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];

        var dt = new Date(date);
        var getmonth = dt.getMonth() + 1
        var datestr = dt.getDate() + '-' + getmonth + '-' + dt.getFullYear()
        // console.log(datestr)
        this.setState({
            selectedDOB: date
        })
        localStorage.setItem("DOBStr", datestr)
    }

    api_getUserProfile = () => {
        // console.log(this.state.user_id)
        axios.get('users/getUserData', {
            params: {
                user_id: localStorage.getItem("user_id")
            },
        })
            .then((response) => {
                let data = response.data;
                // console.log("get userData response===")
                // console.log(data)
                // console.log("===")
                if (response.data.data === "error") {


                } else {
                    console.log("success")
                    this.setState({
                        userDataObj: response.data.dataObj
                    })
                    var userInfo = response.data.dataobj;
                    // console.log(userInfo.first_name)
                    if (userInfo.profile_url === "") {
                        localStorage.setItem("profile_pic", profile_pic_default)
                    } else {
                        localStorage.setItem("profile_pic", userInfo.profile_url)
                        this.setState({ profilePicUrl: userInfo.profile_url })
                    }

                    // console.log("dob===")


                    var mobilenumber = response.data.dataobj.country_code + " " + response.data.dataobj.mobile_no
                    this.setState({
                        first_name: userInfo.first_name,
                        last_name: userInfo.last_name,
                        email: userInfo.email,
                        mobile: mobilenumber,
                    })
                    var dob = userInfo.date_of_birth
                    if (dob.length > 2) {
                        // console.log(userInfo.date_of_birth)
                        var dateParts = dob.split("-");
                        // month is 0-based, that's why we need dataParts[1] - 1
                        var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                        // console.log(dateObject)
                        // console.log("dob===")
                        var dt = dateObject
                        var getmonth = dt.getMonth() + 1
                        var datestr = dt.getDate() + '-' + getmonth + '-' + dt.getFullYear()
                        // console.log(datestr)
                        localStorage.setItem("DOBStr", datestr)
                        this.setState({ selectedDOB: dateObject })
                    }
                    var gender = userInfo.gender
                    if (dob.length > 2) {
                        if (userInfo.gender === "male") {
                            this.setState({
                                isMaleChecked: true,
                                isFemaleChecked: false
                            })
                        } else {
                            this.setState({
                                isMaleChecked: false,
                                isFemaleChecked: true
                            })
                        }
                        this.setState({ genderValue: userInfo.gender })
                    }
                }

            }).catch((error) => {
                console.log(error);
            });
    };

    api_UpdateUserData = e => {
        // console.log("Update user data Clicked ....")
        localStorage.setItem("First_name", this.state.first_name)
        localStorage.setItem("Last_name", this.state.last_name)

        axios
            .post('/users/updateUserProfile', {
                "user_id": localStorage.getItem("user_id"),
                "date_of_birth": localStorage.getItem("DOBStr"),
                "gender": this.state.genderValue,
                "first_name": this.state.first_name,
                "last_name": this.state.last_name,
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                if (resp.data.data === "error") {
                    if (resp.data.error_code === "1007") {
                        this.setState({
                            isError: true,
                            showSuccessMSg: false,
                            ErrorMsg: resp.data.msg
                        })
                    } else {
                        this.setState({
                            isError: true,
                            showSuccessMSg: false,
                            ErrorMsg: resp.data.msg
                        })

                    }
                } else {
                    this.setState({
                        isError: false,
                        showSuccessMSg: true,
                        ErrorMsg: resp.data.msg
                    })

                }

                setTimeout(() => {
                    this.setState({
                        showSuccessMSg: false,
                        isError: false,
                        proceed: true
                    })
                }, 2000)
            }).catch((err) => {
                console.log(err);
            })

    }

    handleMaleRadioChange = (event) => {
        // console.log(event)
        this.setState({
            genderValue: 'male',
            isMaleChecked: true,
            isFemaleChecked: false,
            isError: false,
            ErrorMsg: "Please select gender"
        })
    }
    handleFemaleRadioChange = (event) => {
        // console.log(event)
        this.setState({
            genderValue: 'female',
            isMaleChecked: false,
            isFemaleChecked: true,
            isError: false,
            ErrorMsg: "Please select gender"
        })
    }

    handleInputChange(event) {

        //  event.preventDefault();

        // console.log(event)
        if (event) {
            this.setState({
                selectedFile: event,
            })

            const options = {
                onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor(loaded * 100 / total);
                    // console.log(`${loaded}kb of ${total}kb | ${percent}%`)

                    if (percent < 100) {
                        this.setState({ uploadPercentage: percent })
                    }
                }
            }

            const data = new FormData();
            data.append('profile_pic', event, event.name)
            data.append('user_id', localStorage.getItem("user_id"))


            axios.post("/users/uploadUserProfilePic", data, options)
                .then(res => {
                    // console.log(res);
                    if (res.data.data === "error") {
                        this.setState({
                            isError: true,
                            showSuccessMSg: false,
                            ErrorMsg: res.data.msg
                        })
                        setTimeout(() => {
                            this.setState({
                                showSuccessMSg: false,
                                isError: false
                            })
                        }, 2000)

                    } else {

                        this.setState({ uploadPercentage: 100 }, () => {
                            setTimeout(() => {
                                this.setState({
                                    uploadPercentage: 0,
                                    uploadBtnClicked: false,
                                    profilePicUrl: res.data.profile_url
                                })
                                localStorage.setItem("profile_pic", res.data.profile_url)
                                var save_profile_data = this.check_profile_data_filled()
                                if (save_profile_data){
                                    this.api_UpdateUserData()
                                }else{
                                this.setState({
                                    isError: false,
                                    showSuccessMSg: true,
                                    ErrorMsg: res.data.msg
                                })
                                setTimeout(() => {
                                    this.setState({
                                        showSuccessMSg: false,
                                        isError: false,
                                        proceed: true
                                    })
                                }, 2000)
                            }
                            }, 1000);

                        })

                    }

                })

        }
    }
    handleChangePassClick = () => {
        this.setState({
            showChangePassModal: true,
            new_password: '',
            confirm_password: ''
        })
    }
    handleNewPassChange = (e) => {
        var value = e.target.value
        value = value.split(" ").join("")
        this.setState({
            isNewPassError: false,
            newPassErrormsg: ""
        })
        this.setState({ new_password: value })
    }
    handleConfirmPassChange = (e) => {
        var value = e.target.value
        value = value.split(" ").join("")
        this.setState({
            isConfirmError: false,
            confirmPassErrormsg: ""
        })
        this.setState({ confirm_password: value })
    }
    hidePasswordModal = () => {
        this.setState({ showChangePassModal: !this.state.showChangePassModal })
    }
    handleUpdatePassword = () => {
        if (this.state.new_password === '') {
            this.setState({
                isNewPassError: true,
                newPassErrormsg: "Please enter new password"
            })
            return
        }

        var pattern = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?._!@$%^&*-]).{6,80}$/);
        if (!pattern.test(this.state.new_password)) {
            this.setState({
                isNewPassError: true,
                newPassErrormsg: "The password must be at least 6 characters long and it must contain atleast one capital case character, atleast one small case character, atleast one number and atleast punctuation"
            })

            return
        }
        if (this.state.confirm_password === '') {
            this.setState({
                isConfirmError: true,
                confirmPassErrormsg: "Please enter confirm password"
            })
            return
        }
        if (this.state.new_password !== this.state.confirm_password) {
            this.setState({
                isConfirmError: true,
                confirmPassErrormsg: "password did not match"
            })
            return
        }
        this.api_UpdatePassword()
    }
    toggleShowNewPassword = () => {
        this.setState({ newPasswordHidden: !this.state.newPasswordHidden });
    }
    toggleShowConfirmPassword = () => {
        this.setState({ confirmPasswordHidden: !this.state.confirmPasswordHidden });
    }
    api_UpdatePassword = e => {
        // console.log("Update user data Clicked ....")
        var convertedPassword = this.state.new_password
        convertedPassword = sha256(convertedPassword)

        axios
            .post('/users/updateUserPassword', {
                "user_id": localStorage.getItem("user_id"),
                "password": convertedPassword,
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                this.setState({ showChangePassModal: !this.state.showChangePassModal })
                if (resp.data.data === "error") {

                    this.setState({
                        isError: true,
                        showSuccessMSg: false,
                        ErrorMsg: resp.data.msg
                    })
                    setTimeout(() => {
                        this.setState({
                            showSuccessMSg: false,
                            isError: false
                        })
                    }, 2000)

                } else {
                    this.setState({
                        isError: false,
                        showSuccessMSg: true,
                        ErrorMsg: resp.data.msg
                    })

                }

                setTimeout(() => {
                    this.setState({
                        showSuccessMSg: false,
                        isError: false
                    })
                }, 2000)
            })

    }
    render() {
        if (this.state.proceed) {
            return <Redirect to="/new-visa" />
        }
        return (
            <>
                <div>

                    <h4><b>My Profile</b></h4>
                </div>

                <MDBCard style={{ marginBottom: "5rem" }}>
                    <MDBCardBody>
                        <MDBRow className="mt-2">
                            <MDBCol size="12" sm="5" lg="5">

                                <TextField
                                    style={{ width: '100%' }}
                                    // id="standard-error-helper-text"
                                    label="First name"
                                    defaultValue=""
                                    value={this.state.first_name}
                                    onChange={this.handleFistname}
                                    error={this.state.isFirstnameValid}
                                    helperText={this.state.firstname_error_text}
                                    autoComplete="off"
                                    inputProps={{style: {textTransform: 'capitalize'}}}
                                // disabled
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol size="12" sm="5" lg="5"  >
                                {/* <MDBInput label="Last Name" value = {this.state.last_name}/> */}
                                <TextField
                                    style={{ width: '100%' }}
                                    error={this.state.isLastnameValid}
                                    // id="standard-error-helper-text"
                                    label="Last name"
                                    defaultValue=""
                                    value={this.state.last_name}
                                    onChange={this.handleLastname}
                                    helperText={this.state.lastname_error_text}
                                    autoComplete="off"
                                    inputProps={{style: {textTransform: 'capitalize'}}}
                                // disabled

                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol size="12" sm="5" lg="5"  >
                                {/* <MDBInput label="Email" value = {this.state.email}/> */}
                                <TextField
                                    style={{ width: '100%' }}
                                    error={this.state.isEmailValid}
                                    // id="standard-error-helper-text"
                                    label="Email"
                                    defaultValue=""
                                    value={this.state.email}
                                    onChange={this.handleEmail}
                                    helperText={this.state.email_error_text}
                                    autoComplete="off"
                                    disabled
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol size="12" sm="5" lg="5"  >
                                {/* <MDBInput label="Country" value = {this.state.country}/> */}
                                <TextField
                                    style={{ width: '100%' }}
                                    error={this.state.isMobileValid}
                                    // id="standard-error-helper-text"
                                    label="Mobile number"
                                    defaultValue=""
                                    value={this.state.mobile}
                                    onChange={this.handleMobile}
                                    helperText={this.state.mobile_error_text}
                                    autoComplete="off"
                                    disabled
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol size="12" sm="5" lg="5" >

                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker style={{ width: "100%" }}

                                        variant="inline"
                                        format="dd-MM-yyyy"
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Date of Birth"
                                        value={this.state.selectedDOB}
                                        onChange={this.handleStartDateChange}
                                        autoOk
                                        disableFuture
                                        error=''
                                        onClick = {()=>this.setState({showCalendar:!this.state.showCalendar})}
                                        onClose={()=>this.setState({showCalendar:!this.state.showCalendar})}
                                        open={this.state.showCalendar}
                                        helperText={''}
                                        //minDate={addDays(new Date(), 1)}
                                        //maxDate={addDays(new Date(), 10)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol size="6" sm="6" lg="6">
                                <small>Gender</small><br />
                                <MDBRow>

                                    <MDBCol  >
                                        <input type="radio" checked={this.state.isMaleChecked} id="male_type" name="male_type" value="Male" onChange={this.handleMaleRadioChange} />  Male
                                            </MDBCol>
                                    <MDBCol  >
                                        <input type="radio" checked={this.state.isFemaleChecked} id="female_type" name="visa_type" value="Female" onChange={this.handleFemaleRadioChange} /> Female
                                            </MDBCol>
                                    <MDBCol  ></MDBCol>

                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">

                            <MDBCol size="12" sm="4" lg="4"  >
                                <TextField
                                    style={{ width: '100%' }}
                                    // error={this.state.isMobileValid}
                                    // id="standard-error-helper-text"
                                    type='password'
                                    label="Password"
                                    defaultValue="1234567890"
                                    value={this.state.password}
                                    onChange={this.handlePassword}
                                    helperText={this.state.password_error_text}
                                    autoComplete="off"
                                    disabled
                                /></MDBCol>
                            <MDBCol style={{ marginTop: '1%', textAlign: 'left' }}>
                                <a onClick={() => this.handleChangePassClick()} style={{ color: 'black', textDecoration: 'underline', marginLeft: '-1%' }}>Change Password</a>
                            </MDBCol>

                        </MDBRow>
                        <MDBRow className="mt-1">
                            <MDBCol lg="6" style={{ marginTop: '2%' }}>

                                <MDBRow>
                                    <MDBCol   >
                                        <FilePicker
                                            extensions={['jpg', 'jpeg', 'png']}
                                            maxSize={20}
                                            dims={{ minWidth: 100, maxWidth: 500, minHeight: 100, maxHeight: 500 }}
                                            onChange={FileObject => (/* do something with base64 encoded string */ this.handleInputChange(FileObject))}
                                        //onError={errMsg => (/* do something with err msg string onClick={this.handleUploadBtnClick}*/)
                                        >
                                            <Avatar size={70} src={this.state.profilePicUrl} className="rounded-circle z-depth-1-half"></Avatar>
                                        </FilePicker>
                                    </MDBCol>
                                    <MDBCol style={{ marginTop: '2%', textAlign: 'left' }} >
                                        <FilePicker
                                            extensions={['jpg', 'jpeg', 'png']}
                                            dims={{ minWidth: 100, maxWidth: 500, minHeight: 100, maxHeight: 500 }}
                                            onChange={FileObject => (/* do something with base64 encoded string */ this.handleInputChange(FileObject))}
                                        //onError={errMsg => (/* do something with err msg string onClick={this.handleUploadBtnClick}*/)
                                        >

                                            <a href="#" onClick={this.handleForgotPassword} style={{ color: 'black', textDecoration: 'underline' }}>Upload profile picture</a>
                                        </FilePicker>
                                    </MDBCol>
                                    <MDBCol></MDBCol>
                                    <MDBCol></MDBCol>
                                </MDBRow>

                            </MDBCol>

                        </MDBRow>
                        <MDBRow><MDBCol size="12" sm="5" lg="3">
                        </MDBCol>
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>
                {this.state.showChangePassModal &&
                    <MDBModal centered isOpen={this.state.showChangePassModal} toggle={this.hidePasswordModal}  >
                        <MDBModalHeader toggle={this.hidePasswordModal}>Change Password</MDBModalHeader>
                        <MDBModalBody>
                            <MDBRow>
                                <MDBCol>
                                    <TextField
                                        className="w-100"
                                        error={this.state.isNewPassError}
                                        //id="standard-error-helper-text"
                                        type={this.state.newPasswordHidden ? 'password' : 'text'}
                                        label="New Password"
                                        defaultValue=""
                                        value={this.state.new_password}
                                        onChange={this.handleNewPassChange}
                                        helperText={this.state.newPassErrormsg}
                                    /> 
                                    {this.state.newPasswordHidden ? 
                                    <i onClick={this.toggleShowNewPassword} id="icon" style={{ position: 'absolute', bottom: '10%', right: '3%' , cursor : "pointer" }} className="fa fa-fw fa-eye-slash" />
                                     : <i onClick={this.toggleShowNewPassword} id="icon" style={{ position: 'absolute', bottom: '10%', right: '3%' , cursor : "pointer" }} className="fa fa-fw fa-eye" /> }
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-4">
                                <MDBCol>
                                    <TextField
                                        className="w-100"
                                        error={this.state.isConfirmError}
                                        //id="standard-error-helper-text"
                                        type={this.state.confirmPasswordHidden ? 'password' : 'text'}
                                        label="Confirm Password"
                                        defaultValue=""
                                        value={this.state.confirm_password}
                                        onChange={this.handleConfirmPassChange}
                                        helperText={this.state.confirmPassErrormsg}
                                    />
                                    {this.state.confirmPasswordHidden ? 
                                    <i onClick={this.toggleShowConfirmPassword} id="icon" style={{ position: 'absolute', bottom: '10%', right: '3%' , cursor : "pointer" }} className="fa fa-fw fa-eye-slash" />
                                    :
                                    <i onClick={this.toggleShowConfirmPassword} id="icon" style={{ position: 'absolute', bottom: '10%', right: '3%' , cursor : "pointer" }} className="fa fa-fw fa-eye" />
                                    }
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-4"></MDBRow>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='dark' style={{ textTransform: 'none' }} onClick={this.hidePasswordModal} >Cancel</MDBBtn>
                            <MDBBtn color="none" style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} onClick={() => this.handleUpdatePassword()}>Update</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                }
                <MDBRow>
                    <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" }} color="white" className="pb-1 pt-1 text-right">

                        <MDBRow>
                            <MDBCol size="12" sm="6" md="6" lg="10" style={{ textAlign: 'center' }}>
                                {
                                    this.state.isError &&
                                    <MDBAlert color='danger'>{this.state.ErrorMsg}</MDBAlert>
                                }
                                {
                                    this.state.showSuccessMSg &&
                                    <MDBAlert color='success'>{this.state.ErrorMsg}</MDBAlert>
                                }
                            </MDBCol>
                            <MDBCol size="12" sm="6" md="6" lg="2">
                                <MDBBtn style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={() => this.handleUpdateBtnClick()}>Update</MDBBtn>
                            </MDBCol>
                        </MDBRow>
                    </MDBFooter>
                </MDBRow>
            </>
        )
    }
}

export default MyProfile;
